/* Lone Bandit — homepage interactions */
(function () {
  // Sticky nav scroll state
  var nav = document.getElementById('nav');
  function onScroll() {
    if (!nav) return;
    if (window.scrollY > 60) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // Mobile drawer toggle
  var navToggle = document.getElementById('nav-toggle');
  var navDrawer = document.getElementById('nav-drawer');
  function openDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.add('is-open');
    navDrawer.setAttribute('aria-hidden', 'false');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-drawer-open');
  }
  function closeDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.remove('is-open');
    navDrawer.setAttribute('aria-hidden', 'true');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-drawer-open');
  }
  if (navToggle && navDrawer) {
    navToggle.addEventListener('click', openDrawer);
    navDrawer.querySelectorAll('[data-nav-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navDrawer.classList.contains('is-open')) closeDrawer();
    });
  }

  // Chapter tabs
  var chapterBtns = document.querySelectorAll('.chapter-nav__btn');
  chapterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      chapterBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Email capture
  var emailForm = document.getElementById('email-form');
  var emailSuccess = document.getElementById('email-success');
  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!document.getElementById('email-input').value) return;
    emailForm.hidden = true;
    emailSuccess.hidden = false;
  });

  // Popup — auto-open after 2.2s, dismissible
  var popup = document.getElementById('popup');
  var popupClose = document.getElementById('popup-close');
  var popupSkip = document.getElementById('popup-skip');
  var popupForm = document.getElementById('popup-form');
  var popupSuccess = document.getElementById('popup-success');
  var popupSubmit = popupForm.querySelector('.popup__submit');
  var popupInput = document.getElementById('popup-email');

  function openPopup() { popup.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closePopup() { popup.classList.remove('is-open'); document.body.style.overflow = ''; }

  setTimeout(openPopup, 2200);

  popupClose.addEventListener('click', closePopup);
  popupSkip.addEventListener('click', closePopup);
  popup.addEventListener('click', function (e) { if (e.target === popup) closePopup(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

  popupForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!popupInput.value) return;
    popupInput.hidden = true;
    popupSubmit.hidden = true;
    popupSkip.hidden = true;
    popupSuccess.hidden = false;
    setTimeout(closePopup, 1600);
  });
})();
